import { Form } from '~/shared/api'

export default class AccountUsersImportForm extends Form {
  file: File | null = null

  constructor(files: File[] | null) {
    super()

    this.fillForm(files)
  }

  fillForm(files: File[] | null) {
    this.file = files && files.length > 0 ? files[0] : null
  }
}
